// Haptics via the Vibration API (Android). iPhones have no Vibration API and are skipped silently, as are browsers
// before the first tap (Chrome blocks vibration until the page has had a user gesture) and people who ask for
// reduced motion. Patterns follow the moments in the v2 spec, section 3.
export type HapticKind = 'tap' | 'join' | 'lock' | 'tick' | 'success' | 'fail' | 'podium';
export const HAPTICS: Readonly<Record<HapticKind, number | readonly number[]>> = {
  tap: 10,                    // a light confirmation
  join: 15,                   // M1 join success
  lock: 20,                   // M5 lock-in
  tick: 8,                    // M4 each of the last three seconds
  success: [30, 40, 30],      // M6 right
  fail: 80,                   // M7 wrong
  podium: [30, 40, 30, 40, 60], // M10 podium
};

export function haptic(kind: HapticKind): void {
  try {
    if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
    const activation = (navigator as Navigator & { userActivation?: { hasBeenActive: boolean } }).userActivation;
    if (activation && !activation.hasBeenActive) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const p = HAPTICS[kind];
    navigator.vibrate(typeof p === 'number' ? p : [...p]);
  } catch { /* not supported */ }
}
